<material-navbar
        [menuPosition]="settings.get('vebto.navbar.defaultPosition', 'custom-page-navbar')"
             *ngIf="!(page$ | async)?.hide_nav && !settings.get('vebto.customPages.hideNavbar') && showNavbar"
></material-navbar>
<section>
        <div class="container article-body" [innerHTML]="body$ | async"></div>
</section>
<loading-indicator
  [isVisible]="loading$ | async"
  class="overlay"
></loading-indicator>
<app-footer class="container"></app-footer>